import {defineCustomElement, ref} from "vue";
import ExperienceBookNowCustomElement from "../CustomElements/ExperienceBookNow.ce.vue";
import {BOOK_NOW_WIDGET_TYPE, BookNowWidgetType} from "../Contracts/WidgetTypes/BookNowType";
import {WIDGET_CONFIGURATION} from "../Constants/di";
import {getLogger} from "../Services/LoggingService";
import {boostrapCustomElementApp} from "./Bootstrap";
import {applyWhenConnected} from "./applyWhenConnected";
import {InvalidRequestError} from "../Services/BookingkitApi/Errors/InvalidRequestError";
import {AxiosError} from "axios";
export const ExperienceBookNow = defineCustomElement(ExperienceBookNowCustomElement, {
    configureApp(app) {
        const readyState = ref(false);
        const widgetConfiguration = ref<Required<BookNowWidgetType>|undefined>();
        app.provide('readyState', readyState);
        app.provide(WIDGET_CONFIGURATION, widgetConfiguration);
        boostrapCustomElementApp<BookNowWidgetType>(BOOK_NOW_WIDGET_TYPE, app)
            .then(({configuration, hostElement}) => {
                // Only start rendering while the host element is connected, so Vue
                // never patches into a detached shadow root (insertBefore crash).
                applyWhenConnected(hostElement, () => {
                    widgetConfiguration.value = configuration;
                    readyState.value = true;
                });
            })
            .catch((e: Error) => {
                if(!( e instanceof InvalidRequestError) && !( e instanceof AxiosError)) {
                    getLogger().error(e);
                }
            });
    },
});
